import { render, staticRenderFns } from "./NavigationMenuSettings.vue?vue&type=template&id=3d10e718&"
import script from "./NavigationMenuSettings.vue?vue&type=script&lang=js&"
export * from "./NavigationMenuSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports